import React from "react";
import PBPImage from "../../images/banner-promotion.png";
import * as Tabs from "@radix-ui/react-tabs";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./Carousel";
import * as Accordion from "@radix-ui/react-accordion";
import "../../style/gradient.css";
import moment, { lang } from "moment";
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "gatsby";
import { isLoggedIn } from "../../services/Auth";
import { navigate } from "gatsby";
import { useEffect, useState } from "react";

const stepsImages = [
  {
    src:
      "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/Step_1_684e9a1b42.png",
    number: "1",
  },
  {
    src:
      "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/Step_2_08e83658f8.png",
    number: "2",
  },
  {
    src:
      "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/Step_3_b429225f86.png",
    number: "3",
  },
  {
    src:
      "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/Step_4_df0ea08a86.png",
    number: "4",
  },
  {
    src:
      "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/Step_5_25d018be12.png",
    number: "5",
  },
  {
    src:
      "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/Step_6_9bc7a11e11.png",
    number: "6",
  },
];

const golfClubStepsImages = [
  {
    src: {
      en:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/5_Slider_1_Member_s_Benefits_AYANA_REWARDS_Membership_1600_x_1600_0e9d12d851.jpg",
      ja:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/JA_Slider_1_AYANA_REWARDS_Member_s_Benefits_jap_686ea65f4a.jpg",
      zh:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/ZH_Slider_1_AYANA_REWARDS_Member_s_Benefits_chi_86bd95c671.jpg",
    },

    number: "1",
  },
  {
    src: {
      en:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/5_Slider2_Annual_Riverside_AYANA_REWARDS_Membership_1600_x_1600_2_be87dc6b11.jpg",
      ja:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/JA_Slider_2_Annual_Riverside_Membership_Benefit_Jap_986a2e66a0.jpg",
      zh:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/ZH_Slider_2_Annual_Riverside_Membership_Benefit_Chi_79952579ad.jpg",
    },
    number: "2",
  },
  {
    src: {
      en:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/5_Slider_3_Long_term_riverside_AYANA_REWARDS_Membership_1600_x_1600_3_8cf8467df6.jpg",
      ja:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/JA_Slider_3_Long_Term_Riverside_Membership_Benefit_Jap_949ff951a9.jpg",
      zh:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/ZH_Slider_3_Long_Term_Riverside_Membership_Benefit_Chi_9e745c72d7.jpg",
    },
    number: "3",
  },
  {
    src: {
      en:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/5_Slider_4_Tiered_Bonus_Points_AYANA_REWARDS_Membership_1600_x_1600_4_c02566360c.jpg",
      ja:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/JA_Slider_4_Tiered_Bonus_Points_Jap_91c00b1331.jpg",
      zh:
        "https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/ZH_Slider_4_Tiered_Bonus_Points_Chi_f7d91997ec.jpg",
    },
    number: "4",
  },
];

const MobileStepsCarousel = (langData) => {
  const [mobileStepsApi, setMobileStepsApi] = React.useState();
  const [mobileStepsCurrent, setMobileStepsCurrent] = React.useState(0);
  const [mobileStepsCount, setMobileStepsCount] = React.useState(0);

  React.useEffect(() => {
    if (!mobileStepsApi) {
      return;
    }

    setMobileStepsCount(mobileStepsApi.scrollSnapList().length);
    setMobileStepsCurrent(mobileStepsApi.selectedScrollSnap() + 1);

    mobileStepsApi.on("select", () => {
      setMobileStepsCurrent(mobileStepsApi.selectedScrollSnap() + 1);
    });
  }, [mobileStepsApi]);

  return (
    <div className="tw-overflow-hidden md:tw-hidden">
      <Carousel
        setApi={setMobileStepsApi}
        className="w-full max-w-xs tw-flex tw-flex-col tw-gap-5">
        <CarouselContent>
          <CarouselItem>
            <div className="tw-flex tw-flex-col tw-gap-5">
              <img src={stepsImages[0].src} className="tw-w-[400px]" />
              <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                  {stepsImages[0].number}
                </span>
                <span className="tw-text-base">
                  {langData.langData.how_it_works.first}
                </span>
              </p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-flex-col tw-gap-5">
              <img src={stepsImages[1].src} className="tw-w-[400px]" />
              <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                  {stepsImages[1].number}
                </span>
                <span className="tw-text-base">
                  {langData.langData.how_it_works.second}
                </span>
              </p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-flex-col tw-gap-5">
              <img src={stepsImages[2].src} className="tw-w-[400px]" />
              <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                  {stepsImages[2].number}
                </span>
                <span className="tw-text-base">
                  {langData.langData.how_it_works.third}
                </span>
              </p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-flex-col tw-gap-5">
              <img src={stepsImages[3].src} className="tw-w-[400px]" />
              <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                  {stepsImages[3].number}
                </span>
                <span className="tw-text-base">
                  {langData.langData.how_it_works.fourth}
                </span>
              </p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-flex-col tw-gap-5">
              <img src={stepsImages[4].src} className="tw-w-[400px]" />
              <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-justify-center tw-items-center">
                  {stepsImages[4].number}
                </span>
                <span className="tw-text-base">
                  {langData.langData.how_it_works.fifth}
                </span>
              </p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-flex-col tw-gap-5">
              <img src={stepsImages[5].src} className="tw-w-[400px]" />
              <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                  {stepsImages[5].number}
                </span>
                <span className="tw-text-base">
                  {langData.langData.how_it_works.sixth}
                </span>
              </p>
            </div>
          </CarouselItem>
        </CarouselContent>
        <div className="tw-flex tw-items-center tw-gap-5 tw-h-full tw-relative tw-justify-center">
          <CarouselPrevious className="!tw-static tw-translate-y-0 tw-bg-[#37B0E5]/20 disabled:tw-bg-[#999896]/20 tw-text-[#37B0E5] disabled:tw-text-[#999896]" />
          <div>
            {Array.from(Array(mobileStepsCount).keys()).map((i) => (
              <button
                key={i}
                className={`tw-mx-2 tw-h-1.5 tw-w-1.5 tw-flex-grow tw-rounded-full tw-p-0  ${
                  i === mobileStepsCurrent - 1
                    ? "tw-bg-[#37B0E5]"
                    : "tw-bg-[#E8E8E8]"
                }`}
                onClick={() => mobileStepsApi?.scrollTo(i)}
              />
            ))}
          </div>
          <CarouselNext
            className="!tw-static tw-translate-y-0 tw-bg-[#37B0E5]/20 disabled:tw-bg-[#999896]/20 tw-text-[#37B0E5] disabled:tw-text-[#999896]"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                className="tw-rotate-180"
                viewBox="0 0 17 16"
                fill="none">
                <g id="Icons/chevron_24px">
                  <path
                    id="Vector"
                    d="M5.1665 7.99999L10.4998 2.66666L11.2465 3.41332L6.65984 7.99999L11.2465 12.5867L10.4998 13.3333L5.1665 7.99999Z"
                    fill="currentColor"
                  />
                </g>
              </svg>
            }
          />
        </div>
      </Carousel>
    </div>
  );
};

const GolfClubMobileStepsCarousel = (langData) => {
  const [mobileStepsApi, setMobileStepsApi] = React.useState();
  const [mobileStepsCurrent, setMobileStepsCurrent] = React.useState(0);
  const [mobileStepsCount, setMobileStepsCount] = React.useState(0);

  React.useEffect(() => {
    if (!mobileStepsApi) {
      return;
    }

    setMobileStepsCount(mobileStepsApi.scrollSnapList().length);
    setMobileStepsCurrent(mobileStepsApi.selectedScrollSnap() + 1);

    mobileStepsApi.on("select", () => {
      setMobileStepsCurrent(mobileStepsApi.selectedScrollSnap() + 1);
    });
  }, [mobileStepsApi]);

  return (
    <div className="tw-overflow-hidden md:tw-hidden">
      <Carousel
        setApi={setMobileStepsApi}
        className="w-full max-w-xs tw-flex tw-flex-col tw-gap-5">
        <CarouselContent>
          <CarouselItem>
            <div className="tw-flex tw-flex-col tw-gap-5">
              <img
                src={golfClubStepsImages[0].src[langData.locale]}
                className="tw-w-[400px]"
              />
              <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                  {golfClubStepsImages[0].number}
                </span>
                <span className="tw-text-base tw-h-[72px]">
                  {langData.langData.how_it_works.first}
                </span>
              </p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-flex-col tw-gap-5">
              <img
                src={golfClubStepsImages[1].src[langData.locale]}
                className="tw-w-[400px]"
              />
              <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                  {golfClubStepsImages[1].number}
                </span>
                <span className="tw-text-base tw-h-[72px]">
                  {langData.langData.how_it_works.second}
                </span>
              </p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-flex-col tw-gap-5">
              <img
                src={golfClubStepsImages[2].src[langData.locale]}
                className="tw-w-[400px]"
              />
              <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                  {golfClubStepsImages[2].number}
                </span>
                <span className="tw-text-base tw-h-[72px]">
                  {langData.langData.how_it_works.third}
                </span>
              </p>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-flex-col tw-gap-5">
              <img
                src={golfClubStepsImages[3].src[langData.locale]}
                className="tw-w-[400px]"
              />
              <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                  {golfClubStepsImages[3].number}
                </span>
                <span className="tw-text-base tw-h-[72px]">
                  {langData.langData.how_it_works.fourth}
                </span>
              </p>
            </div>
          </CarouselItem>
        </CarouselContent>
        <div className="tw-flex tw-items-center tw-gap-5 tw-h-full tw-relative tw-justify-center">
          <CarouselPrevious className="!tw-static tw-translate-y-0 tw-bg-[#37B0E5]/20 disabled:tw-bg-[#999896]/20 tw-text-[#37B0E5] disabled:tw-text-[#999896]" />
          <div>
            {Array.from(Array(mobileStepsCount).keys()).map((i) => (
              <button
                key={i}
                className={`tw-mx-2 tw-h-1.5 tw-w-1.5 tw-flex-grow tw-rounded-full tw-p-0  ${
                  i === mobileStepsCurrent - 1
                    ? "tw-bg-[#37B0E5]"
                    : "tw-bg-[#E8E8E8]"
                }`}
                onClick={() => mobileStepsApi?.scrollTo(i)}
              />
            ))}
          </div>
          <CarouselNext
            className="!tw-static tw-translate-y-0 tw-bg-[#37B0E5]/20 disabled:tw-bg-[#999896]/20 tw-text-[#37B0E5] disabled:tw-text-[#999896]"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                className="tw-rotate-180"
                viewBox="0 0 17 16"
                fill="none">
                <g id="Icons/chevron_24px">
                  <path
                    id="Vector"
                    d="M5.1665 7.99999L10.4998 2.66666L11.2465 3.41332L6.65984 7.99999L11.2465 12.5867L10.4998 13.3333L5.1665 7.99999Z"
                    fill="currentColor"
                  />
                </g>
              </svg>
            }
          />
        </div>
      </Carousel>
    </div>
  );
};

const DesktopStepsCarousel = (langData) => {
  const [desktopStepsApi, setDesktopStepsApi] = React.useState();
  const [desktopStepsCurrent, setDesktopStepsCurrent] = React.useState(0);
  const [desktopStepsCount, setDesktopStepsCount] = React.useState(0);

  React.useEffect(() => {
    if (!desktopStepsApi) {
      return;
    }

    setDesktopStepsCount(desktopStepsApi.scrollSnapList().length);
    setDesktopStepsCurrent(desktopStepsApi.selectedScrollSnap() + 1);

    desktopStepsApi.on("select", () => {
      setDesktopStepsCurrent(desktopStepsApi.selectedScrollSnap() + 1);
    });
  }, [desktopStepsApi]);

  return (
    <div className="tw-overflow-hidden tw-hidden md:tw-block tw-max-w-[840px]">
      <Carousel
        setApi={setDesktopStepsApi}
        className="w-full max-w-xs tw-flex tw-flex-col tw-gap-5">
        <CarouselContent>
          <CarouselItem>
            <div className="tw-flex tw-gap-4 tw-justify-center">
              <div className="tw-flex tw-flex-col tw-gap-5">
                <img
                  src={stepsImages[0].src}
                  className="tw-h-[448px] tw-w-[400px]"
                />
                <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                  <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                    {stepsImages[0].number}
                  </span>
                  <span className="tw-text-base">
                    {langData.langData.how_it_works.first}
                  </span>
                </p>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-5">
                <img
                  src={stepsImages[1].src}
                  className="tw-h-[448px] tw-w-[400px]"
                />
                <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                  <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                    {stepsImages[1].number}
                  </span>
                  <span className="tw-text-base">
                    {langData.langData.how_it_works.second}
                  </span>
                </p>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-gap-4 tw-justify-center">
              <div className="tw-flex tw-flex-col tw-gap-5">
                <img
                  src={stepsImages[2].src}
                  className="tw-h-[448px] tw-w-[400px]"
                />
                <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                  <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                    {stepsImages[2].number}
                  </span>
                  <span className="tw-text-base">
                    {langData.langData.how_it_works.third}
                  </span>
                </p>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-5">
                <img
                  src={stepsImages[3].src}
                  className="tw-h-[448px] tw-w-[400px]"
                />
                <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                  <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                    {stepsImages[3].number}
                  </span>
                  <span className="tw-text-base">
                    {langData.langData.how_it_works.fourth}
                  </span>
                </p>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-gap-4 tw-justify-center">
              <div className="tw-flex tw-flex-col tw-gap-5">
                <img
                  src={stepsImages[4].src}
                  className="tw-h-[448px] tw-w-[400px]"
                />
                <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                  <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-justify-center tw-items-center">
                    {stepsImages[4].number}
                  </span>
                  <span className="tw-text-base">
                    {langData.langData.how_it_works.fifth}
                  </span>
                </p>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-5">
                <img
                  src={stepsImages[5].src}
                  className="tw-h-[448px] tw-w-[400px]"
                />
                <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet">
                  <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                    {stepsImages[5].number}
                  </span>
                  <span className="tw-text-base">
                    {langData.langData.how_it_works.sixth}
                  </span>
                </p>
              </div>
            </div>
          </CarouselItem>
        </CarouselContent>
        <div className="tw-flex tw-items-center tw-gap-5 tw-h-full tw-relative tw-justify-center">
          <CarouselPrevious
            className="!tw-static tw-translate-y-0 tw-bg-[#37B0E5]/20 disabled:tw-bg-[#999896]/20 tw-text-[#37B0E5] disabled:tw-text-[#999896]"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none">
                <g id="Icons/chevron_24px">
                  <path
                    id="Vector"
                    d="M5.1665 7.99999L10.4998 2.66666L11.2465 3.41332L6.65984 7.99999L11.2465 12.5867L10.4998 13.3333L5.1665 7.99999Z"
                    fill="currentColor"
                  />
                </g>
              </svg>
            }
          />
          <div>
            {Array.from(Array(desktopStepsCount).keys()).map((i) => (
              <button
                key={i}
                className={`tw-mx-2 tw-h-1.5 tw-w-1.5 tw-flex-grow tw-rounded-full tw-p-0  ${
                  i === desktopStepsCurrent - 1
                    ? "tw-bg-[#37B0E5]"
                    : "tw-bg-[#E8E8E8]"
                }`}
                onClick={() => desktopStepsApi?.scrollTo(i)}
              />
            ))}
          </div>
          <CarouselNext
            className="!tw-static tw-translate-y-0 tw-bg-[#37B0E5]/20 disabled:tw-bg-[#999896]/20 tw-text-[#37B0E5] disabled:tw-text-[#999896]"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                className="tw-rotate-180"
                viewBox="0 0 17 16"
                fill="none">
                <g id="Icons/chevron_24px">
                  <path
                    id="Vector"
                    d="M5.1665 7.99999L10.4998 2.66666L11.2465 3.41332L6.65984 7.99999L11.2465 12.5867L10.4998 13.3333L5.1665 7.99999Z"
                    fill="currentColor"
                  />
                </g>
              </svg>
            }
          />
        </div>
      </Carousel>
    </div>
  );
};

const GolfClubDesktopStepsCarousel = (langData) => {
  const [desktopStepsApi, setDesktopStepsApi] = React.useState();
  const [desktopStepsCurrent, setDesktopStepsCurrent] = React.useState(0);
  const [desktopStepsCount, setDesktopStepsCount] = React.useState(0);

  React.useEffect(() => {
    if (!desktopStepsApi) {
      return;
    }

    setDesktopStepsCount(desktopStepsApi.scrollSnapList().length);
    setDesktopStepsCurrent(desktopStepsApi.selectedScrollSnap() + 1);

    desktopStepsApi.on("select", () => {
      setDesktopStepsCurrent(desktopStepsApi.selectedScrollSnap() + 1);
    });
  }, [desktopStepsApi]);

  return (
    <div className="tw-overflow-hidden tw-hidden md:tw-block tw-max-w-[840px]">
      <Carousel
        setApi={setDesktopStepsApi}
        className="w-full max-w-xs tw-flex tw-flex-col tw-gap-5">
        <CarouselContent>
          <CarouselItem>
            <div className="tw-flex tw-gap-4 tw-justify-center">
              <div className="tw-flex tw-flex-col tw-gap-5 tw-w-[400px]">
                <img
                  src={golfClubStepsImages[0].src[langData.locale]}
                  className="tw-h-[400px] tw-w-full"
                />
                <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet tw-w-full">
                  <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                    {golfClubStepsImages[0].number}
                  </span>
                  <span className="tw-text-base">
                    {langData.langData.how_it_works.first}
                  </span>
                </p>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-5 tw-w-[400px]">
                <img
                  src={golfClubStepsImages[1].src[langData.locale]}
                  className="tw-h-[400px] tw-w-full"
                />
                <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet tw-w-full">
                  <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                    {golfClubStepsImages[1].number}
                  </span>
                  <span className="tw-text-base">
                    {langData.langData.how_it_works.second}
                  </span>
                </p>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="tw-flex tw-gap-4 tw-justify-center">
              <div className="tw-flex tw-flex-col tw-gap-5 tw-w-[400px]">
                <img
                  src={golfClubStepsImages[2].src[langData.locale]}
                  className="tw-h-[400px] tw-w-full"
                />
                <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet tw-w-full">
                  <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                    {golfClubStepsImages[2].number}
                  </span>
                  <span className="tw-text-base">
                    {langData.langData.how_it_works.third}
                  </span>
                </p>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-5 tw-w-[400px]">
                <img
                  src={golfClubStepsImages[3].src[langData.locale]}
                  className="tw-h-[400px] tw-w-full"
                />
                <p className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-leading-5 tw-tracking-[0.15px] tw-font-harriet tw-w-full">
                  <span className="tw-rounded-full tw-border tw-border-black tw-border-solid tw-max-w-[28px] tw-w-full tw-h-7 tw-inline-flex tw-items-center tw-justify-center">
                    {golfClubStepsImages[3].number}
                  </span>
                  <span className="tw-text-base">
                    {langData.langData.how_it_works.fourth}
                  </span>
                </p>
              </div>
            </div>
          </CarouselItem>
        </CarouselContent>
        <div className="tw-flex tw-items-center tw-gap-5 tw-h-full tw-relative tw-justify-center">
          <CarouselPrevious
            className="!tw-static tw-translate-y-0 tw-bg-[#37B0E5]/20 disabled:tw-bg-[#999896]/20 tw-text-[#37B0E5] disabled:tw-text-[#999896]"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none">
                <g id="Icons/chevron_24px">
                  <path
                    id="Vector"
                    d="M5.1665 7.99999L10.4998 2.66666L11.2465 3.41332L6.65984 7.99999L11.2465 12.5867L10.4998 13.3333L5.1665 7.99999Z"
                    fill="currentColor"
                  />
                </g>
              </svg>
            }
          />
          <div>
            {Array.from(Array(desktopStepsCount).keys()).map((i) => (
              <button
                key={i}
                className={`tw-mx-2 tw-h-1.5 tw-w-1.5 tw-flex-grow tw-rounded-full tw-p-0  ${
                  i === desktopStepsCurrent - 1
                    ? "tw-bg-[#37B0E5]"
                    : "tw-bg-[#E8E8E8]"
                }`}
                onClick={() => desktopStepsApi?.scrollTo(i)}
              />
            ))}
          </div>
          <CarouselNext
            className="!tw-static tw-translate-y-0 tw-bg-[#37B0E5]/20 disabled:tw-bg-[#999896]/20 tw-text-[#37B0E5] disabled:tw-text-[#999896]"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                className="tw-rotate-180"
                viewBox="0 0 17 16"
                fill="none">
                <g id="Icons/chevron_24px">
                  <path
                    id="Vector"
                    d="M5.1665 7.99999L10.4998 2.66666L11.2465 3.41332L6.65984 7.99999L11.2465 12.5867L10.4998 13.3333L5.1665 7.99999Z"
                    fill="currentColor"
                  />
                </g>
              </svg>
            }
          />
        </div>
      </Carousel>
    </div>
  );
};

export default function PayByPoints(props) {
  const { isAuthenticated } = useAuth0();
  const generateHref = (hotelCode, localtionCode) => {
    return `${process.env.GATSBY_ABE_URL}/${
      props.locale
    }/rooms?date_from=${moment().format("YYYY-MM-DD")}&date_to=${moment()
      .add(1, "day")
      .format(
        "YYYY-MM-DD"
      )}&location_code=${localtionCode}&property_main=${hotelCode}&rooms=1&adults=2&children=0&booking_code=${
      isAuthenticated ? "AYANAREWARDS" : ""
    }&currency=${
      props.locale === "zh" ? "CNY" : "USD"
    }&utm_source=website&utm_medium=ayanarewards_paywithpoints&utm_content=${hotelCode}`;
  };
  return (
    <div className="-tw-mb-[60px] md:tw-m-0">
      <div className="tw-relative">
        <div className="tw-absolute tw-bg-center tw-z-[5] tw-inset-0 grad">
          <div className="tw-flex tw-flex-col tw-gap-5 tw-p-5 tw-absolute tw-bottom-3 md:tw-bottom-10 tw-inset-x-0">
            <div className="tw-flex tw-flex-col tw-gap-2 tw-bottom-0 tw-text-white md:tw-gap-2 md:tw-w-[1064px] md:tw-mx-auto">
              <h1 className="tw-text-center md:tw-text-left tw-text-xl tw-font-normal tw-font-harriet tw-m-0 tw-leading-6 md:tw-text-[32px] md:tw-leading-9">
                <span>{props.langData.intro.title1}</span>
                <br />
                <span>{props.langData.intro.title2}</span>
              </h1>
              <p className="tw-text-center md:tw-text-left tw-opacity-80 tw-font-opensans tw-text-sm tw-tracking-[0.15px] md:tw-leading-5 tw-leading-5 tw-m-0">
                {props.langData.intro.subtitle}
              </p>
            </div>
            <div className="md:tw-w-[1064px] md:tw-mx-auto tw-flex tw-justify-center md:tw-justify-start">
              <button
                onClick={props.openWidgetAction}
                className="tw-cursor-pointer tw-font-gotham tw-border tw-border-white tw-border-solid tw-text-white tw-w-fit tw-self-center md:tw-self-start tw-px-5 tw-py-3 tw-uppercase tw-text-sm tw-tracking-[0.5px] tw-bg-[#37B0E5] tw-leading-4">
                {props.langData.intro.cta}
              </button>
            </div>
          </div>
        </div>
        <img
          src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/750x960_AYANA_Komodo_87611450c1.jpg"
          className="tw-w-full tw-object-cover md:tw-hidden"
          alt="Pay By Points"
        />
        <img
          src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/2880x560_AYANA_Komodo_8364f7fe32.jpg"
          className="tw-w-full tw-object-cover tw-hidden md:tw-block"
          alt="Pay By Points"
        />
      </div>
      <div className="tw-p-6 tw-flex tw-flex-col tw-gap-6 md:tw-p-20 md:tw-gap-10">
        <h2 className="tw-text-center tw-font-harriet tw-text-2xl md:tw-text-[34px] tw-text-[#464646] !tw-font-light tw-tracking-[0.28px] tw-leading-normal tw-m-0">
          {props.langData.title}
        </h2>
        <div className="tw-flex tw-flex-col tw-gap-6 md:tw-flex-row md:tw-gap-10 md:tw-justify-center">
          <div className="tw-p-5 md:tw-p-4 tw-rounded-lg tw-flex tw-flex-col tw-gap-5 md:tw-gap-3 tw-border tw-border-solid tw-border-[#E8E8E8] md:tw-max-w-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              className="tw-h-[60px] tw-w-[60px] md:tw-h-[80px] md:tw-w-[80px]"
              viewBox="0 0 60 60"
              fill="none">
              <g id="Frame 2608784">
                <g id="Group 7135">
                  <path
                    id="scatter_plot"
                    d="M49.7094 51.7748C48.2543 51.7748 47.0088 51.2839 45.9726 50.3023C44.9365 49.3207 44.4184 48.1407 44.4184 46.7622C44.4184 45.3838 44.9365 44.2038 45.9726 43.2222C47.0088 42.2405 48.2543 41.7497 49.7094 41.7497C51.1644 41.7497 52.41 42.2405 53.4461 43.2222C54.4823 44.2038 55.0003 45.3838 55.0003 46.7622C55.0003 48.1407 54.4823 49.3207 53.4461 50.3023C52.41 51.2839 51.1644 51.7748 49.7094 51.7748ZM49.7094 49.2685C50.4369 49.2685 51.0597 49.0231 51.5777 48.5323C52.0958 48.0415 52.3549 47.4515 52.3549 46.7622C52.3549 46.073 52.0958 45.483 51.5777 44.9922C51.0597 44.5014 50.4369 44.256 49.7094 44.256C48.9818 44.256 48.3591 44.5014 47.841 44.9922C47.3229 45.483 47.0639 46.073 47.0639 46.7622C47.0639 47.4515 47.3229 48.0415 47.841 48.5323C48.3591 49.0231 48.9818 49.2685 49.7094 49.2685ZM36.4819 48.0154C35.0269 48.0154 33.7813 47.5246 32.7451 46.5429C31.709 45.5613 31.1909 44.3813 31.1909 43.0029C31.1909 41.6244 31.709 40.4444 32.7451 39.4628C33.7813 38.4812 35.0269 37.9904 36.4819 37.9904C37.9369 37.9904 39.1825 38.4812 40.2187 39.4628C41.2548 40.4444 41.7729 41.6244 41.7729 43.0029C41.7729 44.3813 41.2548 45.5613 40.2187 46.5429C39.1825 47.5246 37.9369 48.0154 36.4819 48.0154ZM36.4819 45.5091C37.2094 45.5091 37.8322 45.2637 38.3503 44.7729C38.8684 44.2821 39.1274 43.6921 39.1274 43.0029C39.1274 42.3136 38.8684 41.7236 38.3503 41.2328C37.8322 40.742 37.2094 40.4966 36.4819 40.4966C35.7544 40.4966 35.1316 40.742 34.6135 41.2328C34.0954 41.7236 33.8364 42.3136 33.8364 43.0029C33.8364 43.6921 34.0954 44.2821 34.6135 44.7729C35.1316 45.2637 35.7544 45.5091 36.4819 45.5091ZM41.7729 37.9904C40.3179 37.9904 39.0723 37.4995 38.0361 36.5179C37 35.5363 36.4819 34.3563 36.4819 32.9778C36.4819 31.5994 37 30.4194 38.0361 29.4378C39.0723 28.4561 40.3179 27.9653 41.7729 27.9653C43.2279 27.9653 44.4735 28.4561 45.5096 29.4378C46.5458 30.4194 47.0639 31.5994 47.0639 32.9778C47.0639 34.3563 46.5458 35.5363 45.5096 36.5179C44.4735 37.4995 43.2279 37.9904 41.7729 37.9904ZM41.7729 35.4841C42.5004 35.4841 43.1232 35.2387 43.6413 34.7479C44.1593 34.2571 44.4184 33.6671 44.4184 32.9778C44.4184 32.2886 44.1593 31.6986 43.6413 31.2078C43.1232 30.717 42.5004 30.4716 41.7729 30.4716C41.0454 30.4716 40.4226 30.717 39.9045 31.2078C39.3864 31.6986 39.1274 32.2886 39.1274 32.9778C39.1274 33.6671 39.3864 34.2571 39.9045 34.7479C40.4226 35.2387 41.0454 35.4841 41.7729 35.4841Z"
                    fill="#ACBFC6"
                  />
                  <path
                    id="add_card"
                    d="M9.23327 43.8623C8.06926 43.8623 7.07279 43.4478 6.24387 42.6189C5.41495 41.79 5.00049 40.7935 5.00049 39.6295V14.2328C5.00049 13.0688 5.41495 12.0723 6.24387 11.2434C7.07279 10.4145 8.06926 10 9.23327 10H43.0956C44.2596 10 45.2561 10.4145 46.085 11.2434C46.9139 12.0723 47.3284 13.0688 47.3284 14.2328V26.9311H9.23327V39.6295H30.3972V43.8623H9.23327ZM9.23327 18.4656H43.0956V14.2328H9.23327V18.4656Z"
                    fill="#ACBFC6"
                  />
                </g>
              </g>
            </svg>
            <p className="tw-font-harriet tw-font-medium tw-tracking-[0.28px] tw-text-[#9C8F74] tw-text-lg m-0">
              {props.langData.pros.first.title}
            </p>
            <p className="tw-text-sm tw-font-light tw-font-harriet tw-leading-5 tw-text-[#747474] m-0">
              {props.langData.pros.first.description}
            </p>
          </div>
          <div className="tw-p-5 md:tw-p-4 tw-rounded-lg tw-flex tw-flex-col tw-gap-5 md:tw-gap-3 tw-border tw-border-solid tw-border-[#E8E8E8] md:tw-max-w-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              className="tw-h-[60px] tw-w-[60px] md:tw-h-[80px] md:tw-w-[80px]"
              viewBox="0 0 80 80"
              fill="none">
              <g id="clarity:coin-bag-line">
                <g id="Group 7147">
                  <path
                    id="Vector"
                    d="M48.5786 62.345C48.5786 61.483 48.3416 60.6564 47.9196 60.0469C47.4976 59.4374 46.9254 59.095 46.3286 59.095H32.8286C32.2319 59.095 31.6596 59.4374 31.2376 60.0469C30.8157 60.6564 30.5786 61.483 30.5786 62.345C30.5786 63.2069 30.8157 64.0336 31.2376 64.6431C31.6596 65.2526 32.2319 65.595 32.8286 65.595H46.3286C46.9254 65.595 47.4976 65.2526 47.9196 64.6431C48.3416 64.0336 48.5786 63.2069 48.5786 62.345Z"
                    fill="#ACBFC6"
                  />
                  <path
                    id="Vector_2"
                    d="M50.2905 49.9263H36.7905C36.1938 49.9263 35.6215 50.2687 35.1995 50.8782C34.7776 51.4877 34.5405 52.3143 34.5405 53.1763C34.5405 54.0382 34.7776 54.8649 35.1995 55.4744C35.6215 56.0839 36.1938 56.4263 36.7905 56.4263H50.2905C50.8873 56.4263 51.4596 56.0839 51.8815 55.4744C52.3035 54.8649 52.5405 54.0382 52.5405 53.1763C52.5405 52.3143 52.3035 51.4877 51.8815 50.8782C51.4596 50.2687 50.8873 49.9263 50.2905 49.9263Z"
                    fill="#ACBFC6"
                  />
                  <path
                    id="Vector_3"
                    d="M49.1875 68.2627H35.6875C35.0908 68.2627 34.5185 68.6051 34.0965 69.2146C33.6746 69.8241 33.4375 70.6507 33.4375 71.5127C33.4375 72.3746 33.6746 73.2013 34.0965 73.8108C34.5185 74.4203 35.0908 74.7627 35.6875 74.7627H49.1875C49.7842 74.7627 50.3565 74.4203 50.7785 73.8108C51.2004 73.2013 51.4375 72.3746 51.4375 71.5127C51.4375 70.6507 51.2004 69.8241 50.7785 69.2146C50.3565 68.6051 49.7842 68.2627 49.1875 68.2627Z"
                    fill="#ACBFC6"
                  />
                  <path
                    id="Vector_4"
                    d="M69.5824 67.2627H55.2877C54.7461 67.2627 54.2267 67.6051 53.8437 68.2146C53.4608 68.8241 53.2456 69.6507 53.2456 70.5127C53.2456 71.3746 53.4608 72.2013 53.8437 72.8108C54.2267 73.4203 54.7461 73.7627 55.2877 73.7627H69.5824C70.1239 73.7627 70.6434 73.4203 71.0263 72.8108C71.4093 72.2013 71.6244 71.3746 71.6244 70.5127C71.6244 69.6507 71.4093 68.8241 71.0263 68.2146C70.6434 67.6051 70.1239 67.2627 69.5824 67.2627Z"
                    fill="#ACBFC6"
                  />
                  <path
                    id="Vector_5"
                    d="M71.6246 57.095H57.3299C56.7883 57.095 56.2689 57.4374 55.886 58.0469C55.503 58.6564 55.2878 59.483 55.2878 60.345C55.2878 61.2069 55.503 62.0336 55.886 62.6431C56.2689 63.2526 56.7883 63.595 57.3299 63.595H71.6246C72.1662 63.595 72.6856 63.2526 73.0686 62.6431C73.4515 62.0336 73.6667 61.2069 73.6667 60.345C73.6667 59.483 73.4515 58.6564 73.0686 58.0469C72.6856 57.4374 72.1662 57.095 71.6246 57.095Z"
                    fill="#ACBFC6"
                  />
                  <path
                    id="Vector_6"
                    d="M71.7065 54.0102C71.108 46.8199 69.154 39.8079 65.9477 33.3443C62.8763 27.5033 58.4509 22.4827 53.0417 18.7025L57.9427 7.89978C58.1007 7.57693 58.1707 7.21809 58.1456 6.85953C58.1205 6.50096 58.0012 6.15538 57.7998 5.85769C57.6139 5.59654 57.3692 5.38282 57.0853 5.23381C56.8015 5.08481 56.4866 5.00472 56.1661 5.00001H22.8187C22.4754 4.99916 22.1375 5.08486 21.8361 5.24921C21.5347 5.41355 21.2796 5.65123 21.0943 5.94026C20.9091 6.2293 20.7997 6.56037 20.7763 6.90287C20.7529 7.24536 20.8162 7.58823 20.9604 7.89978L25.9636 18.7433C20.5938 22.5271 16.1986 27.5312 13.1392 33.3443C8.74871 41.5126 7.38051 51.4985 7.01293 58.4212C6.95274 59.4346 7.10312 60.4495 7.45458 61.402C7.80604 62.3545 8.35097 63.2238 9.05502 63.9552C9.795 64.674 10.6712 65.2375 11.6321 65.6127C12.593 65.988 13.6192 66.1673 14.6504 66.1403H27.3113V62.1786H14.487C14.0248 62.1772 13.5677 62.0824 13.1431 61.8999C12.7185 61.7174 12.3352 61.451 12.0161 61.1167C11.6965 60.7851 11.4497 60.3904 11.2914 59.9578C11.1332 59.5253 11.067 59.0645 11.0971 58.605C11.383 53.2751 12.5062 43.1259 16.7333 35.223C19.7132 29.5605 24.1196 24.7739 29.5168 21.3368H31.5589C30.1751 23.2511 28.9001 25.2419 27.7402 27.2997C26.5588 29.4893 25.5549 31.7701 24.7383 34.1203L27.536 35.999C28.3625 33.5607 29.3799 31.1914 30.5787 28.9129C32.0508 26.2636 33.7233 23.7309 35.5818 21.3368H37.6239C38.9938 24.611 39.9607 28.0396 40.5033 31.5472C40.9469 34.1511 41.1655 36.7883 41.1567 39.4297L44.3832 37.163C44.2933 35.1093 44.0751 33.0632 43.7298 31.0367C43.1818 27.7248 42.3063 24.4755 41.1159 21.3368H42.7087L44.567 17.2526H29.7823L26.0044 9.08419H52.9804L47.8752 20.2544C48.7503 20.7232 49.5899 21.2556 50.387 21.8473C55.3904 25.2992 59.4939 29.8998 62.3537 35.2638C65.2181 41.1455 66.996 47.4963 67.6018 54.0102H71.7065Z"
                    fill="#ACBFC6"
                  />
                </g>
              </g>
            </svg>
            <p className="tw-font-harriet tw-font-medium tw-tracking-[0.28px] tw-text-[#9C8F74] tw-text-lg m-0">
              {props.langData.pros.second.title}
            </p>
            <p className="tw-text-sm tw-font-light tw-font-harriet tw-leading-5 tw-text-[#747474] m-0">
              {props.langData.pros.second.description}
            </p>
          </div>
        </div>
      </div>
      <div className="tw-bg-[#9C8F74] tw-bg-opacity-[15%]">
        <div className="tw-flex tw-flex-col tw-gap-5 md:tw-gap-[60px] md:tw-flex-row md:tw-py-20 tw-py-10 md:!tw-min-h-[700px] !tw-min-h-[762px] md:tw-max-w-[1064px] md:tw-mx-auto">
          <div className="tw-w-full md:tw-w-[333px] tw-shrink-0 tw-flex tw-flex-col tw-gap-5 tw-px-8 md:tw-p-0">
            <h3 className="tw-m-0 tw-font-harriet !tw-font-light tw-text-2xl md:tw-text-[34px] tw-leading-7 tw-tracking-[0.28px] tw-text-[#9C8F74] tw-text-center md:tw-text-left md:tw-leading-10">
              {props.langData.preferred_dest.title}
            </h3>
            <p className="tw-m-0 tw-font-harriet !tw-font-light tw-leading-5 tw-tracking-[0.15px] tw-text-center tw-text-[#747474] tw-text-sm md:tw-text-left md:tw-text-lg md:tw-leading-7">
              {props.langData.preferred_dest.subtitle}
            </p>
          </div>
          <div className="tw-pl-4">
            <Tabs.Root
              defaultValue="bali"
              className="tw-flex tw-flex-col tw-gap-5 tw-antialiased">
              <Tabs.List
                aria-label="AYANA Properties"
                className="tw-flex tw-gap-6 tw-justify-center md:tw-justify-start">
                <Tabs.Trigger
                  value="bali"
                  className="tw-bg-transparent tw-p-0 tw-font-harriet tw-text-sm tw-leading-4 tw-tracking-[0.28px] tw-font-light md:tw-font-normal md:tw-leading-6 md:tw-text-xl tw-text-[#464646] data-[state=active]:tw-text-[#44C8F5] data-[state=active]:tw-border-b-2 data-[state=active]:tw-border-solid data-[state=active]:tw-border-[#44C8F5] tw-pb-2">
                  {props.langData.preferred_dest.bali}
                </Tabs.Trigger>
                <Tabs.Trigger
                  value="komodo"
                  className="tw-bg-transparent tw-p-0 tw-font-harriet tw-text-sm tw-leading-4 tw-tracking-[0.28px] tw-font-light md:tw-font-normal md:tw-leading-6 md:tw-text-xl tw-text-[#464646] data-[state=active]:tw-text-[#44C8F5] data-[state=active]:tw-border-b-2 data-[state=active]:tw-border-solid data-[state=active]:tw-border-[#44C8F5] tw-pb-2">
                  {props.langData.preferred_dest.komodo}
                </Tabs.Trigger>
                <Tabs.Trigger
                  value="jakarta"
                  className="tw-bg-transparent tw-p-0 tw-font-harriet tw-text-sm tw-leading-4 tw-tracking-[0.28px] tw-font-light md:tw-font-normal md:tw-leading-6 md:tw-text-xl tw-text-[#464646] data-[state=active]:tw-text-[#44C8F5] data-[state=active]:tw-border-b-2 data-[state=active]:tw-border-solid data-[state=active]:tw-border-[#44C8F5] tw-pb-2">
                  {props.langData.preferred_dest.jakarta}
                </Tabs.Trigger>
              </Tabs.List>
              <Tabs.Content value="bali">
                <div className="tw-hidden md:tw-grid md:tw-grid-rows-2 md:tw-grid-cols-2 md:tw-gap-5">
                  <a
                    className="tw-relative"
                    href={generateHref("VILLA", "Bali")}>
                    <div className="tw-absolute tw-inset-0 tw-bg-center grad-thumb">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.VILLA}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/626x400_AYANA_Villas_222324f67a.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                  <a
                    className="tw-relative"
                    href={generateHref("SEGARA", "Bali")}>
                    <div className="tw-absolute tw-inset-0 tw-bg-center grad-thumb">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.SEGARA}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/626x400_AYANA_Segara_c7c321f782.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                  <a
                    className="tw-relative"
                    href={generateHref("ARSB", "Bali")}>
                    <div className="tw-absolute tw-inset-0 tw-bg-center grad-thumb">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.ARSB}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/626x400_AYANA_Bali_7f517772b5.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                  <a className="tw-relative" href={generateHref("RJB", "Bali")}>
                    <div className="tw-absolute tw-inset-0 tw-bg-center grad-thumb">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.RJB}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/626x400_RIMBA_ba2ea4de13.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                </div>
                <div className="tw-overflow-hidden md:tw-hidden">
                  <Carousel className="tw-w-full tw-max-w-xs">
                    <CarouselContent>
                      <CarouselItem>
                        <div className="tw-flex tw-flex-col tw-gap-5">
                          <a
                            className="tw-relative"
                            href={generateHref("VILLA", "Bali")}>
                            <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                              <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                                <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                                  {props.langData.preferred_dest.VILLA}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="6"
                                  viewBox="0 0 40 6"
                                  className="tw-w-[40px]"
                                  fill="none">
                                  <path
                                    id="Arrow"
                                    d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </div>
                            <img
                              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/626x400_AYANA_Villas_222324f67a.jpg"
                              className="tw-w-full tw-h-[200px] tw-object-cover"
                              alt="Pay By Points"
                            />
                          </a>
                          <a
                            className="tw-relative"
                            href={generateHref("SEGARA", "Bali")}>
                            <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                              <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                                <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                                  {props.langData.preferred_dest.SEGARA}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="6"
                                  viewBox="0 0 40 6"
                                  className="tw-w-[40px]"
                                  fill="none">
                                  <path
                                    id="Arrow"
                                    d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </div>
                            <img
                              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/626x400_AYANA_Segara_c7c321f782.jpg"
                              className="tw-w-full tw-h-[200px] tw-object-cover"
                              alt="Pay By Points"
                            />
                          </a>
                        </div>
                      </CarouselItem>
                      <CarouselItem>
                        <div className="tw-flex tw-flex-col tw-gap-5">
                          <a
                            className="tw-relative"
                            href={generateHref("ARSB", "Bali")}>
                            <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                              <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                                <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                                  {props.langData.preferred_dest.ARSB}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="6"
                                  viewBox="0 0 40 6"
                                  className="tw-w-[40px]"
                                  fill="none">
                                  <path
                                    id="Arrow"
                                    d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </div>
                            <img
                              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/626x400_AYANA_Bali_7f517772b5.jpg"
                              className="tw-w-full tw-h-[200px] tw-object-cover"
                              alt="Pay By Points"
                            />
                          </a>
                          <a
                            className="tw-relative"
                            href={generateHref("RJB", "Bali")}>
                            <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                              <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                                <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                                  {props.langData.preferred_dest.RJB}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="6"
                                  viewBox="0 0 40 6"
                                  className="tw-w-[40px]"
                                  fill="none">
                                  <path
                                    id="Arrow"
                                    d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </div>
                            <img
                              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/626x400_RIMBA_ba2ea4de13.jpg"
                              className="tw-w-full tw-h-[200px] tw-object-cover"
                              alt="Pay By Points"
                            />
                          </a>
                        </div>
                      </CarouselItem>
                    </CarouselContent>
                  </Carousel>
                </div>
              </Tabs.Content>
              <Tabs.Content
                value="komodo"
                className="tw-justify-center tw-flex">
                <a
                  className="tw-relative tw-max-w-xs"
                  href={generateHref("AKWB", "Komodo")}>
                  <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                    <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                      <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                        {props.langData.preferred_dest.AKWB}
                      </p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="6"
                        viewBox="0 0 40 6"
                        className="tw-w-[40px]"
                        fill="none">
                        <path
                          id="Arrow"
                          d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                  <img
                    src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/626x400_AYANA_Komodo_36ae09a8b7.jpg"
                    className="tw-w-full tw-h-[200px] tw-object-cover"
                    alt="Pay By Points"
                  />
                </a>
              </Tabs.Content>
              <Tabs.Content
                value="jakarta"
                className="tw-flex tw-justify-center">
                <div className="tw-flex tw-flex-col tw-gap-5 md:tw-flex-row">
                  <a
                    className="tw-relative tw-max-w-xs"
                    href={generateHref("JKTHB", "Jakarta")}>
                    <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.JKTHB}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/626x400_AYANA_JKT_c569660576.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                  <a
                    className="tw-relative tw-max-w-xs"
                    href={generateHref("DXKR", "Karawang")}>
                    <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.DXKR}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/Delonix_626_x_400_a_9d7cb6aa91.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                </div>
              </Tabs.Content>
            </Tabs.Root>
          </div>
        </div>
      </div>
      <div className="tw-py-6 tw-px-5 tw-flex tw-flex-col tw-gap-6 md:tw-items-center md:tw-gap-10">
        <h3 className="tw-m-0 tw-text-center tw-font-harriet tw-text-2xl md:tw-text-[34px] !tw-font-light tw-leading-7 tw-tracking-[0.28px] tw-text-[#464646] md:tw-max-w-[625px] md:tw-leading-[42px]">
          {props.langData.how_it_works.title}
        </h3>
        <p className="tw-m-0 tw-font-harriet !tw-font-light tw-text-lg tw-tracking-[0.15px] tw-text-[#747474] md:tw-text-center md:tw-text-2xl md:tw-leading-7">
          {props.langData.how_it_works.subtitle}
        </p>
        <MobileStepsCarousel langData={props.langData} />
        <DesktopStepsCarousel langData={props.langData} />
        <p className="tw-m-0 tw-text-center tw-font-harriet tw-text-lg tw-tracking-[0.15px] tw-text-[#747474] !tw-font-light">
          {props.langData.find_hotels.title}
        </p>
        <button
          onClick={props.openWidgetAction}
          className="tw-cursor-pointer tw-font-gotham tw-text-white tw-w-fit tw-self-center tw-px-5 tw-py-3 tw-uppercase tw-text-sm tw-tracking-[0.5px] tw-bg-[#37B0E5] tw-leading-4 md:-tw-mt-5">
          {props.langData.find_hotels.cta}
        </button>
      </div>
      {props.locale === "en" && (
        <div className="tw-px-5 tw-pb-6 tw-flex tw-flex-col tw-gap-6 md:tw-py-14">
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/D_Earn_Points_EN_80741921f8.png"
            className="tw-w-full tw-object-cover tw-rounded-lg tw-bg-center md:tw-max-w-5xl md:tw-mx-auto tw-hidden md:tw-block"
            alt="Pay By Points"
          />
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/M_Earn_Points_EN_737b88cb15.png"
            className="tw-w-full tw-object-cover tw-rounded-lg tw-bg-center md:tw-max-w-5xl md:tw-mx-auto md:tw-hidden tw-block"
            alt="Pay By Points"
          />
        </div>
      )}
      {props.locale === "ja" && (
        <div className="tw-px-5 tw-pb-6 tw-flex tw-flex-col tw-gap-6 md:tw-py-14">
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/D_Earn_Points_JA_248736ecc3.png"
            className="tw-w-full tw-object-cover tw-rounded-lg tw-bg-center md:tw-max-w-5xl md:tw-mx-auto tw-hidden md:tw-block"
            alt="Pay By Points"
          />
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/M_Earn_Points_JA_5d52e68c38.png"
            className="tw-w-full tw-object-cover tw-rounded-lg tw-bg-center md:tw-max-w-5xl md:tw-mx-auto md:tw-hidden tw-block"
            alt="Pay By Points"
          />
        </div>
      )}
      {props.locale === "zh" && (
        <div className="tw-px-5 tw-pb-6 tw-flex tw-flex-col tw-gap-6 md:tw-py-14">
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/D_Earn_Points_ZH_bf56e8fc65.png"
            className="tw-w-full tw-object-cover tw-rounded-lg tw-bg-center md:tw-max-w-5xl md:tw-mx-auto tw-hidden md:tw-block"
            alt="Pay By Points"
          />
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/M_Earn_Points_ZH_5fefffb067.png"
            className="tw-w-full tw-object-cover tw-rounded-lg tw-bg-center md:tw-max-w-5xl md:tw-mx-auto md:tw-hidden tw-block"
            alt="Pay By Points"
          />
        </div>
      )}
      <div className="tw-flex tw-flex-col tw-gap-6 md:tw-gap-10 tw-px-5 tw-py-6 md:tw-py-10 tw-bg-[#FAF9F8]">
        <h3 className="tw-m-0 !tw-font-light tw-font-harriet tw-text-2xl md:tw-text-[34px] tw-leading-7 tw-tracking-[0.28px] tw-text-center">
          {props.langData.faq.title}
        </h3>
        <Accordion.Root
          collapsible
          defaultValue={["item1"]}
          type="multiple"
          className="tw-w-full tw-flex tw-flex-col tw-gap-3 md:tw-max-w-5xl md:tw-mx-auto">
          <Accordion.Item value="item1">
            <Accordion.Trigger
              asChild
              className="tw-group tw-cursor-pointer tw-pt-0.5">
              <div className="tw-flex tw-items-center tw-gap-2">
                <p className="tw-m-0 tw-text-[#637F8E] tw-font-harriet tw-text-base tw-leading-8 tw-tracking-[0.28px] md:tw-leading-[54px] tw-grow">
                  {props.langData.faq.first.question}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="2"
                  viewBox="0 0 12 2"
                  className="tw-min-w-fit group-data-[state=closed]:tw-hidden"
                  fill="none">
                  <rect width="12" height="2" fill="#979797" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  className="group-data-[state=open]:tw-hidden tw-min-w-fit"
                  fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7 0H5V5H0V7H5V12H7V7H12V5H7V0Z"
                    fill="#979797"
                  />
                </svg>
              </div>
            </Accordion.Trigger>
            <Accordion.Content className="tw-text-[#747474] tw-font-sans tw-text-sm tw-leading-5 -tw-tracking-[0.15px]">
              {props.langData.faq.first.answer}
            </Accordion.Content>
          </Accordion.Item>
          <hr className="tw-w-full tw-m-0 tw-mx-auto tw-border-[#E8E8E8]" />
          <Accordion.Item value="item2">
            <Accordion.Trigger
              asChild
              className="tw-group tw-cursor-pointer tw-pt-0.5">
              <div className="tw-flex tw-items-center tw-gap-2">
                <p className="tw-m-0 tw-text-[#637F8E] tw-font-harriet tw-grow tw-text-base tw-leading-8 tw-tracking-[0.28px] md:tw-leading-[54px]">
                  {props.langData.faq.second.question}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="2"
                  viewBox="0 0 12 2"
                  className="group-data-[state=closed]:tw-hidden tw-min-w-fit"
                  fill="none">
                  <rect width="12" height="2" fill="#979797" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  className="group-data-[state=open]:tw-hidden tw-min-w-fit"
                  fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7 0H5V5H0V7H5V12H7V7H12V5H7V0Z"
                    fill="#979797"
                  />
                </svg>
              </div>
            </Accordion.Trigger>
            <Accordion.Content className="tw-text-[#747474] tw-font-sans tw-text-sm tw-leading-5 -tw-tracking-[0.15px]">
              {props.langData.faq.second.answer}
            </Accordion.Content>
          </Accordion.Item>
          <hr className="tw-w-full tw-m-0 tw-mx-auto tw-border-[#E8E8E8]" />
          <Accordion.Item value="item3">
            <Accordion.Trigger
              asChild
              className="tw-group tw-cursor-pointer tw-pt-0.5">
              <div className="tw-flex tw-items-center tw-gap-2">
                <p className="tw-m-0 tw-text-[#637F8E] tw-grow tw-font-harriet tw-text-base tw-leading-8 tw-tracking-[0.28px] md:tw-leading-[54px]">
                  {props.langData.faq.third.question}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="2"
                  viewBox="0 0 12 2"
                  className="group-data-[state=closed]:tw-hidden tw-min-w-fit"
                  fill="none">
                  <rect width="12" height="2" fill="#979797" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  className="group-data-[state=open]:tw-hidden tw-min-w-fit"
                  fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7 0H5V5H0V7H5V12H7V7H12V5H7V0Z"
                    fill="#979797"
                  />
                </svg>
              </div>
            </Accordion.Trigger>
            <Accordion.Content className="tw-text-[#747474] tw-font-sans tw-text-sm tw-leading-5 -tw-tracking-[0.15px] tw-flex tw-flex-col tw-gap-2">
              <span>{props.langData.faq.third.answer}</span>
              <span>
                {props.langData.tnc}:{" "}
                <Link to={props.tnclink}>{props.tnclink}</Link>
              </span>
            </Accordion.Content>
          </Accordion.Item>
          <hr className="tw-w-full tw-m-0 tw-mx-auto tw-border-[#E8E8E8]" />
        </Accordion.Root>
      </div>
      <div className="md:tw-hidden tw-bg-[#A0BFCA] tw-p-5 tw-font-sans tw-text-white tw-text-xs tw-leading-4 !tw-font-bold tw-tracking-[0.7px]">
        © {new Date().getFullYear()} AYANA HOSPITALITY. ALL RIGHTS RESERVED
      </div>
    </div>
  );
}

export function RiversideGolf(props) {
  const [signupHref, setSignupHref] = useState("");

  useEffect(() => {
    const baseUrl = window.location.origin;
    const path =
      props.locale === "en"
        ? isLoggedIn() === false
          ? "/signup"
          : "/member"
        : isLoggedIn() === false
        ? `/${props.locale}/signup`
        : `/${props.locale}/member`;

    setSignupHref(`${baseUrl}${path}`);
  }, [props.locale]);

  const generateHref = (link) =>
    props.locale == "en"
      ? `${process.env.GATSBY_REWARDS_PROD_BASE_URL}/${link}`
      : `${process.env.GATSBY_REWARDS_PROD_BASE_URL}/${props.locale}/${link}`;

  return (
    <div className="-tw-mb-[60px] md:tw-m-0">
      {props.locale === "en" && (
        <a
          className="tw-relative"
          href="https://www.riverside-golf.com/book-now">
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/2_Landing_Page_Banner_Mobile_AYANA_REWARDS_Landing_Page_750_x_960_0690de65ee.jpg"
            className="tw-w-full tw-object-cover md:tw-hidden"
            alt="Pay By Points"
          />
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/2_Landing_Page_Banner_Desktop_AYANA_REWARDS_Landing_Page_2880x560_7c44b2f6a7.jpg"
            className="tw-w-full tw-object-cover tw-hidden md:tw-block"
            alt="Pay By Points"
          />
        </a>
      )}
      {props.locale === "ja" && (
        <a
          className="tw-relative"
          href="https://www.riverside-golf.com/book-now">
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/JA_Mobile_Enhance_ayana_reward_jap_750_x_960_c290656673.jpg"
            className="tw-w-full tw-object-cover md:tw-hidden"
            alt="Pay By Points"
          />
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/JA_Desktop_Enhance_ayana_reward_jap_2880_x_560_5b61b13cbd.jpg"
            className="tw-w-full tw-object-cover tw-hidden md:tw-block"
            alt="Pay By Points"
          />
        </a>
      )}
      {props.locale === "zh" && (
        <a
          className="tw-relative"
          href="https://www.riverside-golf.com/book-now">
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/ZH_Mobile_Enhance_ayana_reward_chi_750_x_960_e61b6af7c6.jpg"
            className="tw-w-full tw-object-cover md:tw-hidden"
            alt="Pay By Points"
          />
          <img
            src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/ZH_Desktop_Enhance_ayana_reward_chi_2880_x_560_4b5142ae4b.jpg"
            className="tw-w-full tw-object-cover tw-hidden md:tw-block"
            alt="Pay By Points"
          />
        </a>
      )}
      <div className="tw-p-6 tw-flex tw-flex-col tw-gap-6 md:tw-p-20 md:tw-gap-10">
        <h2 className="tw-text-center tw-font-harriet tw-text-2xl md:tw-text-[34px] tw-text-[#464646] !tw-font-light tw-tracking-[0.28px] tw-leading-normal tw-m-0">
          {props.langData.title}
        </h2>
        <div className="tw-flex tw-flex-col tw-gap-6 md:tw-flex-row md:tw-gap-10 md:tw-justify-center">
          <div className="tw-p-5 md:tw-p-4 tw-rounded-lg tw-flex tw-flex-col tw-gap-5 md:tw-gap-3 tw-border tw-border-solid tw-border-[#E8E8E8] md:tw-max-w-lg">
            <img
              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/3_Icon_1_Earn_Points_and_Unlock_Rewards_with_Every_Round_e45caa4af9.jpg"
              className="tw-h-[60px] tw-w-[60px] md:tw-h-[80px] md:tw-w-[80px] bg-cover"></img>
            <p className="tw-font-harriet tw-font-medium tw-tracking-[0.28px] tw-text-[#9C8F74] tw-text-lg m-0">
              {props.langData.pros.first.title}
            </p>
            <p className="tw-text-sm tw-font-light tw-font-harriet tw-leading-5 tw-text-[#747474] m-0">
              {props.langData.pros.first.description}
            </p>
          </div>
          <div className="tw-p-5 md:tw-p-4 tw-rounded-lg tw-flex tw-flex-col tw-gap-5 md:tw-gap-3 tw-border tw-border-solid tw-border-[#E8E8E8] md:tw-max-w-lg">
            <img
              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/3_Icon_2_Unlock_AYANA_Rewards_Exclusive_Benefits_9b160910cc.jpg"
              className="tw-h-[60px] tw-w-[60px] md:tw-h-[80px] md:tw-w-[80px] bg-cover"></img>
            <p className="tw-font-harriet tw-font-medium tw-tracking-[0.28px] tw-text-[#9C8F74] tw-text-lg m-0">
              {props.langData.pros.second.title}
            </p>
            <p className="tw-text-sm tw-font-light tw-font-harriet tw-leading-5 tw-text-[#747474] m-0">
              {props.langData.pros.second.description}
            </p>
            <p className="tw-text-sm tw-font-light tw-font-harriet tw-leading-5 tw-text-[#747474] m-0">
              <em>{props.langData.pros.second.tierLevel}</em>
            </p>
          </div>
        </div>
      </div>
      <div className="tw-bg-[#9C8F74] tw-bg-opacity-[15%]">
        <div className="tw-flex tw-flex-col tw-gap-5 md:tw-gap-[60px] md:tw-flex-row md:tw-py-20 tw-py-10 md:!tw-min-h-[700px] !tw-min-h-[762px] md:tw-max-w-[1064px] md:tw-mx-auto">
          <div className="tw-w-full md:tw-w-[333px] tw-shrink-0 tw-flex tw-flex-col tw-gap-5 tw-px-8 md:tw-p-0">
            <h3 className="tw-m-0 tw-font-harriet !tw-font-light tw-text-2xl md:tw-text-[34px] tw-leading-7 tw-tracking-[0.28px] tw-text-[#9C8F74] tw-text-center md:tw-text-left md:tw-leading-10">
              {props.langData.preferred_dest.title}
            </h3>
            <p className="tw-m-0 tw-font-harriet !tw-font-light tw-leading-5 tw-tracking-[0.15px] tw-text-center tw-text-[#747474] tw-text-sm md:tw-text-left md:tw-text-lg md:tw-leading-7">
              {props.langData.preferred_dest.subtitle}
            </p>
          </div>
          <div className="tw-pl-4">
            <Tabs.Root
              defaultValue="bali"
              className="tw-flex tw-flex-col tw-gap-5 tw-antialiased">
              <Tabs.List
                aria-label="AYANA Properties"
                className="tw-flex tw-gap-6 tw-justify-center md:tw-justify-start">
                <Tabs.Trigger
                  value="bali"
                  className="tw-bg-transparent tw-p-0 tw-font-harriet tw-text-sm tw-leading-4 tw-tracking-[0.28px] tw-font-light md:tw-font-normal md:tw-leading-6 md:tw-text-xl tw-text-[#464646] data-[state=active]:tw-text-[#44C8F5] data-[state=active]:tw-border-b-2 data-[state=active]:tw-border-solid data-[state=active]:tw-border-[#44C8F5] tw-pb-2">
                  {props.langData.preferred_dest.bali}
                </Tabs.Trigger>
                <Tabs.Trigger
                  value="komodo"
                  className="tw-bg-transparent tw-p-0 tw-font-harriet tw-text-sm tw-leading-4 tw-tracking-[0.28px] tw-font-light md:tw-font-normal md:tw-leading-6 md:tw-text-xl tw-text-[#464646] data-[state=active]:tw-text-[#44C8F5] data-[state=active]:tw-border-b-2 data-[state=active]:tw-border-solid data-[state=active]:tw-border-[#44C8F5] tw-pb-2">
                  {props.langData.preferred_dest.komodo}
                </Tabs.Trigger>
                <Tabs.Trigger
                  value="jakarta"
                  className="tw-bg-transparent tw-p-0 tw-font-harriet tw-text-sm tw-leading-4 tw-tracking-[0.28px] tw-font-light md:tw-font-normal md:tw-leading-6 md:tw-text-xl tw-text-[#464646] data-[state=active]:tw-text-[#44C8F5] data-[state=active]:tw-border-b-2 data-[state=active]:tw-border-solid data-[state=active]:tw-border-[#44C8F5] tw-pb-2">
                  {props.langData.preferred_dest.jakarta}
                </Tabs.Trigger>
              </Tabs.List>
              <Tabs.Content value="bali">
                <div className="tw-hidden md:tw-grid md:tw-grid-rows-2 md:tw-grid-cols-2 md:tw-gap-5">
                  <a
                    className="tw-relative"
                    href={generateHref(
                      "reward/?page=1&property=ARSB&category_id=1533"
                    )}>
                    <div className="tw-absolute tw-inset-0 tw-bg-center grad-thumb">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.hotelStay}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_1_Bali_Hotel_Stay_Desktop_AYANA_REWARDS_Landing_Page_626_x_400_8c560b9163.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                  <a
                    className="tw-relative"
                    href={generateHref(
                      "reward/?page=1&property=ARSB&category_id=1532"
                    )}>
                    <div className="tw-absolute tw-inset-0 tw-bg-center grad-thumb">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.giftVoucher}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_1_Bali_Gift_Voucher_Desktop_AYANA_REWARDS_Landing_Page_626_x_400_31442e6a3e.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                  <a
                    className="tw-relative"
                    href={generateHref(
                      "/reward/?page=1&property=ARSB&category_id=1530"
                    )}>
                    <div className="tw-absolute tw-inset-0 tw-bg-center grad-thumb">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.krisFlyerMiles}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_1_Bali_Kris_Flyer_Desktop_AYANA_REWARDS_Landing_Page_626_x_400_aad9f384ba.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                  <a
                    className="tw-relative"
                    href={generateHref(
                      "/reward?page=1&property=KWG&category_id=1532"
                    )}>
                    <div className="tw-absolute tw-inset-0 tw-bg-center grad-thumb">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.diningVoucher}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_1_Bali_Dining_Voucher_desktop_AYANA_REWARDS_Landing_Page_626_x_400_dafc80f170.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                </div>
                <div className="tw-overflow-hidden md:tw-hidden">
                  <Carousel className="tw-w-full tw-max-w-xs">
                    <CarouselContent>
                      <CarouselItem>
                        <div className="tw-flex tw-flex-col tw-gap-5">
                          <a
                            className="tw-relative"
                            href={generateHref(
                              "/reward/?page=1&property=ARSB&category_id=1533"
                            )}>
                            <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                              <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                                <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                                  {props.langData.preferred_dest.hotelStay}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="6"
                                  viewBox="0 0 40 6"
                                  className="tw-w-[40px]"
                                  fill="none">
                                  <path
                                    id="Arrow"
                                    d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </div>
                            <img
                              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_1_Bali_Hotel_Stay_Desktop_AYANA_REWARDS_Landing_Page_626_x_400_8c560b9163.jpg"
                              className="tw-w-full tw-h-[200px] tw-object-cover"
                              alt="Pay By Points"
                            />
                          </a>
                          <a
                            className="tw-relative"
                            href={generateHref(
                              "/reward/?page=1&property=ARSB&category_id=1532"
                            )}>
                            <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                              <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                                <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                                  {props.langData.preferred_dest.giftVoucher}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="6"
                                  viewBox="0 0 40 6"
                                  className="tw-w-[40px]"
                                  fill="none">
                                  <path
                                    id="Arrow"
                                    d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </div>
                            <img
                              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_1_Bali_Gift_Voucher_Desktop_AYANA_REWARDS_Landing_Page_626_x_400_31442e6a3e.jpg"
                              className="tw-w-full tw-h-[200px] tw-object-cover"
                              alt="Pay By Points"
                            />
                          </a>
                        </div>
                      </CarouselItem>
                      <CarouselItem>
                        <div className="tw-flex tw-flex-col tw-gap-5">
                          <a
                            className="tw-relative"
                            href={generateHref(
                              "/reward/?page=1&property=ARSB&category_id=1530"
                            )}>
                            <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                              <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                                <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                                  {props.langData.preferred_dest.krisFlyerMiles}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="6"
                                  viewBox="0 0 40 6"
                                  className="tw-w-[40px]"
                                  fill="none">
                                  <path
                                    id="Arrow"
                                    d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </div>
                            <img
                              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_1_Bali_Kris_Flyer_Desktop_AYANA_REWARDS_Landing_Page_626_x_400_aad9f384ba.jpg"
                              className="tw-w-full tw-h-[200px] tw-object-cover"
                              alt="Pay By Points"
                            />
                          </a>
                          <a
                            className="tw-relative"
                            href={generateHref(
                              "/reward?page=1&property=KWG&category_id=1532"
                            )}>
                            <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                              <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                                <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                                  {props.langData.preferred_dest.diningVoucher}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="6"
                                  viewBox="0 0 40 6"
                                  className="tw-w-[40px]"
                                  fill="none">
                                  <path
                                    id="Arrow"
                                    d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </div>
                            <img
                              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_1_Bali_Dining_Voucher_desktop_AYANA_REWARDS_Landing_Page_626_x_400_dafc80f170.jpg"
                              className="tw-w-full tw-h-[200px] tw-object-cover"
                              alt="Pay By Points"
                            />
                          </a>
                        </div>
                      </CarouselItem>
                    </CarouselContent>
                  </Carousel>
                </div>
              </Tabs.Content>
              <Tabs.Content
                value="komodo"
                className="tw-justify-center tw-flex">
                <div className="tw-flex tw-flex-col tw-gap-5 md:tw-flex-row">
                  <a
                    className="tw-relative tw-max-w-xs"
                    href={generateHref(
                      "/reward/?page=1&property=AKWB&category_id=1533"
                    )}>
                    <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.hotelStay}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_2_Komodo_Hotel_Stay_Desktop_AYANA_REWARDS_Landing_Page_626_x_400_a273c8824c.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                  <a
                    className="tw-relative tw-max-w-xs"
                    href={generateHref(
                      "/reward/?page=1&property=AKWB&category_id=1530"
                    )}>
                    <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.krisFlyerMiles}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_2_Komodo_Kris_Flyer_Desktop_AYANA_REWARDS_Landing_Page_626_x_400_3e19f6ac85.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                </div>
              </Tabs.Content>
              <Tabs.Content
                value="jakarta"
                className="tw-flex tw-justify-center">
                <div className="tw-flex tw-flex-col tw-gap-5 md:tw-flex-row">
                  <a
                    className="tw-relative tw-max-w-xs"
                    href={generateHref("/reward/?page=1&property=JKTHB")}>
                    <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.JKTHB}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_3_Stay_at_AYANA_Jakarta_Desktop_AYANA_REWARDS_Landing_Page_626_x_400_b3fe8339a5.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                  <a
                    className="tw-relative tw-max-w-xs"
                    href={generateHref("/reward/?page=1&property=DXKR")}>
                    <div className="tw-absolute tw-inset-0 grad-thumb tw-bg-center">
                      <div className="tw-bottom-4 tw-left-4 tw-absolute tw-text-white tw-flex tw-flex-col tw-gap-3">
                        <p className="tw-font-sans tw-m-0 tw-text-base tw-leading-5 -tw-tracking-[0.15px]">
                          {props.langData.preferred_dest.DXKR}
                        </p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="6"
                          viewBox="0 0 40 6"
                          className="tw-w-[40px]"
                          fill="none">
                          <path
                            id="Arrow"
                            d="M40 3L35 0.113252L35 5.88675L40 3ZM-4.37114e-08 3.5L35.5 3.5L35.5 2.5L4.37114e-08 2.5L-4.37114e-08 3.5Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                    <img
                      src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/4_Tab_3_Stay_at_Delonix_Desktop_AYANA_REWARDS_Landing_Page_626_x_400_ec170a1745.jpg"
                      className="tw-w-full tw-h-[200px] tw-object-cover"
                      alt="Pay By Points"
                    />
                  </a>
                </div>
              </Tabs.Content>
            </Tabs.Root>
          </div>
        </div>
      </div>
      <div className="tw-py-6 tw-px-5 tw-flex tw-flex-col tw-gap-6 md:tw-items-center md:tw-gap-10">
        <h3 className="tw-m-0 tw-text-center tw-font-harriet tw-text-2xl md:tw-text-[34px] !tw-font-light tw-leading-7 tw-tracking-[0.28px] tw-text-[#464646] md:tw-max-w-[625px] md:tw-leading-[42px]">
          {props.langData.how_it_works.title}
        </h3>
        <GolfClubMobileStepsCarousel
          langData={props.langData}
          locale={props.locale}
        />
        <GolfClubDesktopStepsCarousel
          langData={props.langData}
          locale={props.locale}
        />
        <p className="tw-m-0 tw-text-center tw-font-harriet tw-text-lg tw-tracking-[0.15px] tw-text-[#747474] !tw-font-light">
          {props.langData.find_hotels.title}
        </p>
        <a
          href={signupHref}
          className="tw-cursor-pointer tw-font-gotham tw-text-white tw-w-fit tw-self-center tw-px-5 tw-py-3 tw-uppercase tw-text-sm tw-tracking-[0.5px] tw-bg-[#37B0E5] tw-leading-4 md:-tw-mt-5">
          {props.langData.find_hotels.cta}
        </a>
      </div>
      <div className="tw-flex tw-flex-col tw-gap-6 md:tw-gap-10 tw-px-5 tw-py-6 md:tw-py-10 tw-bg-[#FAF9F8]">
        <h3 className="tw-m-0 !tw-font-light tw-font-harriet tw-text-2xl md:tw-text-[34px] tw-leading-7 tw-tracking-[0.28px] tw-text-center">
          {props.langData.faq.title}
        </h3>
        <Accordion.Root
          collapsible
          defaultValue={["item1"]}
          type="multiple"
          className="tw-w-full tw-flex tw-flex-col tw-gap-3 md:tw-max-w-5xl md:tw-mx-auto">
          <Accordion.Item value="item1">
            <Accordion.Trigger
              asChild
              className="tw-group tw-cursor-pointer tw-pt-0.5">
              <div className="tw-flex tw-items-center tw-gap-2">
                <p className="tw-m-0 tw-text-[#637F8E] tw-font-harriet tw-text-base tw-leading-8 tw-tracking-[0.28px] md:tw-leading-[54px] tw-grow">
                  {props.langData.faq.first.question}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="2"
                  viewBox="0 0 12 2"
                  className="tw-min-w-fit group-data-[state=closed]:tw-hidden"
                  fill="none">
                  <rect width="12" height="2" fill="#979797" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  className="group-data-[state=open]:tw-hidden tw-min-w-fit"
                  fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7 0H5V5H0V7H5V12H7V7H12V5H7V0Z"
                    fill="#979797"
                  />
                </svg>
              </div>
            </Accordion.Trigger>
            {props.locale == "en" && (
              <Accordion.Content className="tw-text-[#747474] tw-font-sans tw-text-sm tw-leading-5 -tw-tracking-[0.15px]">
                {props.langData.faq.first.answer}{" "}
                <a href="https://riverside-gc.com/">
                  {props.langData.faq.first.link}
                </a>
              </Accordion.Content>
            )}
            {props.locale == "ja" && (
              <Accordion.Content className="tw-text-[#747474] tw-font-sans tw-text-sm tw-leading-5 -tw-tracking-[0.15px]">
                リバーサイド ゴルフクラブのウェブサイト{" "}
                <a href="https://riverside-gc.com/">
                  ({props.langData.faq.first.link})
                </a>{" "}
                からオンラインでご予約いただけます。
              </Accordion.Content>
            )}
            {props.locale == "zh" && (
              <Accordion.Content className="tw-text-[#747474] tw-font-sans tw-text-sm tw-leading-5 -tw-tracking-[0.15px]">
                您可以通过河滨高尔夫俱乐部网站{" "}
                <a href="https://riverside-gc.com/">
                  ({props.langData.faq.first.link})
                </a>{" "}
                在线预订开球时间。
              </Accordion.Content>
            )}
          </Accordion.Item>
          <hr className="tw-w-full tw-m-0 tw-mx-auto tw-border-[#E8E8E8]" />
          <Accordion.Item value="item2">
            <Accordion.Trigger
              asChild
              className="tw-group tw-cursor-pointer tw-pt-0.5">
              <div className="tw-flex tw-items-center tw-gap-2">
                <p className="tw-m-0 tw-text-[#637F8E] tw-font-harriet tw-grow tw-text-base tw-leading-8 tw-tracking-[0.28px] md:tw-leading-[54px]">
                  {props.langData.faq.second.question}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="2"
                  viewBox="0 0 12 2"
                  className="group-data-[state=closed]:tw-hidden tw-min-w-fit"
                  fill="none">
                  <rect width="12" height="2" fill="#979797" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  className="group-data-[state=open]:tw-hidden tw-min-w-fit"
                  fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7 0H5V5H0V7H5V12H7V7H12V5H7V0Z"
                    fill="#979797"
                  />
                </svg>
              </div>
            </Accordion.Trigger>
            <Accordion.Content className="tw-text-[#747474] tw-font-sans tw-text-sm tw-leading-5 -tw-tracking-[0.15px]">
              {props.langData.faq.second.answer}
            </Accordion.Content>
          </Accordion.Item>
          <hr className="tw-w-full tw-m-0 tw-mx-auto tw-border-[#E8E8E8]" />
          <Accordion.Item value="item3">
            <Accordion.Trigger
              asChild
              className="tw-group tw-cursor-pointer tw-pt-0.5">
              <div className="tw-flex tw-items-center tw-gap-2">
                <p className="tw-m-0 tw-text-[#637F8E] tw-grow tw-font-harriet tw-text-base tw-leading-8 tw-tracking-[0.28px] md:tw-leading-[54px]">
                  {props.langData.faq.third.question}
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="2"
                  viewBox="0 0 12 2"
                  className="group-data-[state=closed]:tw-hidden tw-min-w-fit"
                  fill="none">
                  <rect width="12" height="2" fill="#979797" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  className="group-data-[state=open]:tw-hidden tw-min-w-fit"
                  fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7 0H5V5H0V7H5V12H7V7H12V5H7V0Z"
                    fill="#979797"
                  />
                </svg>
              </div>
            </Accordion.Trigger>
            <Accordion.Content className="tw-text-[#747474] tw-font-sans tw-text-sm tw-leading-5 -tw-tracking-[0.15px] tw-flex tw-flex-col tw-gap-2">
              <span>{props.langData.faq.third.answer}</span>
            </Accordion.Content>
          </Accordion.Item>
          <hr className="tw-w-full tw-m-0 tw-mx-auto tw-border-[#E8E8E8]" />
        </Accordion.Root>
      </div>
      <div className="md:tw-hidden tw-bg-[#A0BFCA] tw-p-5 tw-font-sans tw-text-white tw-text-xs tw-leading-4 !tw-font-bold tw-tracking-[0.7px]">
        © {new Date().getFullYear()} AYANA HOSPITALITY. ALL RIGHTS RESERVED
      </div>
    </div>
  );
}
